<template>
  <div class="publishings">
    <hero v-if="!isInApp" />
    <trending-publishings
      :publishings="publishings"
      :loading="loading"
      :bookMarks="bookMarks"
      :follwedBloggers="follwedBloggers"
      @bookMarkBlog="handleToggleShelfPublishing"
    />
    <Form />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "@/components/layout/Form";
import Hero from "@/components/other-pages/cornerLibrary/Hero";
import TrendingPublishings from "@/components/other-pages/cornerLibrary/TrendingPublishings";

export default {
  name: "MyApps",
  components: {
    Hero,
    Form,
    TrendingPublishings
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    isInApp() {
      return this.$route.fullPath
        ? this.$route.fullPath.includes("/app")
        : false;
    }
  },
  watch: {
    user(newValue, oldValue) {
      if (newValue.uid) {
        //this.getCollectedCornerPublishings();
      }
    }
  },
  beforeMount() {
    this.loading = true;
  },
  mounted() {
    this.$store.dispatch("listings/getListPublishings").then(publishings => {
      this.publishings = publishings;
      this.loading = false;
    });

    if (this.user) {
      this.getCollectedCornerPublishings();
      //this.getFollowedBloggers();
    }

    // this.currentPath = this.$route.fullPath;
  },
  methods: {
    getCollectedCornerPublishings() {
      if (this.user) {
        this.$store
          .dispatch("user/getCollectedCornerPublishings", this.user.uid)
          .then(publishings => {
            this.shelvedPublishings = publishings;
          });
      }
    },
    handleToggleShelfPublishing(event) {}
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:title", content: "Our Daily Focus" },
        {
          name: "twitter:description",
          content: "The Blog of JourneyBinder.com"
        },
        // image must be an absolute path
        { name: "twitter:image", content: this.logo },
        // Facebook OpenGraph
        { property: "og:title", content: "Our Blog" },
        { property: "og:site_name", content: "Our Daily Focus" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: "The Blog of JourneyBinder.com" }
      ]
    };
  },
  data() {
    return {
      currentPath: "",
      loading: false,
      publishings: [],
      bookMarks: [],
      follwedBloggers: [],
      shelvedPublishings: [],
      tags: [],
      logo: "https://journeybinder.com/img/main_logo.39bf51d2.png"
    };
  },
};
</script>

<style lang="scss" scoped>
.publishings {
  position: relative;
  .overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
  padding-top: 72px;
  @media (min-width: 767px) {
    padding-top: 130px;
  }

  .horizontal-line {
    border-top: 1px solid #ddd;
  }
}
</style>
